module.exports = __webpack_public_path__ + "img/travel@2x.4cdd228a.png";